export const ERROR_MESSAGE = 'NOT_SUPPORTED';
